
import React, { useEffect, useState, Fragment } from 'react';
import { Card, Form, Row, Col, Modal, Button} from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { Auth, LoadingComponent} from 'recupero-comunes'
import { formato_monto, isValidParam, validaNumeros } from '../../../common/Formatos'
import { serviceGetComboMonedas, serviceGetLiquidacionPerdida, serviceGetSituacionPago, servicePostActualizaLiquidacion } from '../../../api/encargado-cia-client';

const ActualizaLiquidacion = ({cfg_form, showModalActLiquidacion, setShowModalActLiquidacion, actualizoLiquidacion, setActualizoLiquidacion}) => {
    const { rutUsuario, codMonedaLocal, codMonedaConsolida } = Auth.currentUser();
    const [loading, setLoading] = useState(false);

    const data_encargado_cia = useSelector((state) => state.encargado_compania)
    const { cfg_form8, casoImplicado, liquidacionPerdida, antecedentesCasos} = data_encargado_cia

    const [antecedentesLiquidacion, setAntecedentesLiquidacion] = useState(null);
    const [monedas, setMonedas] = useState(null);
    const [monedaPago, setMonedaPago] = useState("");
    
    const[montoPago, setMontoPago]=useState(0)
    const[montoPagoNoFormato, setMontoPagoNoFormato]=useState(0)
    const[fechaPago, setFechaPago]=useState("")
    const[situacionPago, setSituacionPago]=useState("")
    const [situaciones, setSituaciones] = useState(null);

    const [monedaIndemniza, setMonedaIndemniza] = useState("");
    const[montoIndemniza, setMontoIndemniza]=useState(0)
    const[montoIndemnizaNoFormato, setMontoIndemnizaNoFormato]=useState(0)
    const[chkInfLiquida, setChkInfLiquida]=useState(0)
    const[fechaInforme, setFechaInforme]=useState("")

    const [monedaProvision, setMonedaProvision] = useState("");
    const[montoProvision, setMontoProvision]=useState(0)
    const[montoProvisionNoFormato, setMontoProvisionNoFormato]=useState(0)

    const[chkFiniquito, setChkFiniquito]=useState(0)
    const [monedaSalvataje, setMonedaSalvataje] = useState("");
    const[montoSalvataje, setMontoSalvataje]=useState(0)
    const[montoSalvatajeNoFormato, setMontoSalvatajeNoFormato]=useState(0)

    const[validaciones, setValidaciones]=useState({})   

    const [respuestaActLiquidacion, setRespuestaActLiquidacion] = useState("");

    const [show, setShow] = useState(false)
    const [showValidaciones, setShowValidaciones] = useState(false)
    const [tipoSiniestro, setTipoSiniestro] = useState("");

    const [fechaSiniestro, setFechaSiniestro] = useState("");


    useEffect(() => {
        if (showModalActLiquidacion) { setLoading(true); initialData() };
    }, [showModalActLiquidacion])

    const initialData = async () => {
        
        isValidParam(antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']) ? setTipoSiniestro(antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']) : setTipoSiniestro('');
        isValidParam(antecedentesCasos.antecedentesCasos[0]['FechaSiniestroFmt']) ? setFechaSiniestro(antecedentesCasos.antecedentesCasos[0]['FechaSiniestroFmt']) : setFechaSiniestro('');
        
        await getComboMonedas();
        await getSituacionPago();

        await initialValues();
        setLoading(false)
    }
    const getLiquidacion = async () => {
        let query = Buffer.from(JSON.stringify({
            "idCaso": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]["IdCaso"],
            "idImplicado":0,
            "idOrganizacion": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]["Compania"],
            "tipoGestion": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoGestion'],
            "tipoSiniestro": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']
          })).toString('base64');
        const response = await serviceGetLiquidacionPerdida(query);
        setAntecedentesLiquidacion(response);
    }
    const getComboMonedas = async () => {
        let codClasCaso = antecedentesCasos && isValidParam(antecedentesCasos.antecedentesCasos[0]['CodClasificacionCaso']) ? antecedentesCasos.antecedentesCasos[0]['CodClasificacionCaso']:""
        const query = Buffer.from(JSON.stringify({ pais: Auth.currentUser().paisOrganizacion, clasBien: codClasCaso })).toString('base64');
        const response = await serviceGetComboMonedas(query);
        setMonedas(response);
    }
    const getSituacionPago = async () => {
        const query = Buffer.from(JSON.stringify({ concepto: 230 })).toString('base64');
        const response = await serviceGetSituacionPago(query);
        setSituaciones(response);
    }
    const initialValues = async () => {

        let liquidacion = liquidacionPerdida.liquidacionPerdida;

        await setModalValues(liquidacion);
    }
    const setModalValues = async (liquidacionPerdida) => {

        isValidParam (liquidacionPerdida.codMonedaPago) ? setMonedaPago(liquidacionPerdida.codMonedaPago) : setMonedaPago('');
        isValidParam (liquidacionPerdida.mtoPago) ? setMontoPago(formato_monto(Math.round(liquidacionPerdida.mtoPago))) : setMontoPago('');
        isValidParam (liquidacionPerdida.mtoPago) ? setMontoPagoNoFormato(Math.round(liquidacionPerdida.mtoPago)) : setMontoPagoNoFormato('');
        isValidParam (liquidacionPerdida.fechaPagoFmt) ? setFechaPago(liquidacionPerdida.fechaPagoFmt) : setFechaPago('');
        isValidParam (liquidacionPerdida.codSituacionPago) ? setSituacionPago(liquidacionPerdida.codSituacionPago) : setSituacionPago('');

        isValidParam (liquidacionPerdida.codMonedaIndeminza) ? setMonedaIndemniza(liquidacionPerdida.codMonedaIndeminza) : setMonedaIndemniza('');
        isValidParam (liquidacionPerdida.mtoIndemnizacion) ? setMontoIndemniza(formato_monto(Math.round(liquidacionPerdida.mtoIndemnizacion))) : setMontoIndemniza('');
        isValidParam (liquidacionPerdida.mtoIndemnizacion) ? setMontoIndemnizaNoFormato(Math.round(liquidacionPerdida.mtoIndemnizacion)) : setMontoIndemnizaNoFormato('');
        isValidParam (liquidacionPerdida.indInformeLiquida) ? setChkInfLiquida(liquidacionPerdida.indInformeLiquida) : setChkInfLiquida('');
        isValidParam (liquidacionPerdida.fechaInformeFmt) ? setFechaInforme(liquidacionPerdida.fechaInformeFmt) : setFechaInforme('');

        isValidParam (liquidacionPerdida.codMonedaProvision) ? setMonedaProvision(liquidacionPerdida.codMonedaProvision) : setMonedaProvision('');
        isValidParam (liquidacionPerdida.mtoProvision) ? setMontoProvision(formato_monto(Math.round(liquidacionPerdida.mtoProvision))) : setMontoProvision('');
        isValidParam (liquidacionPerdida.mtoProvision) ? setMontoProvisionNoFormato(Math.round(liquidacionPerdida.mtoProvision)) : setMontoProvisionNoFormato('');

        isValidParam (liquidacionPerdida.indFiniquito) ? setChkFiniquito(liquidacionPerdida.indFiniquito) : setChkFiniquito('');
        isValidParam (liquidacionPerdida.codMonedaSalvataje) ? setMonedaSalvataje(liquidacionPerdida.codMonedaSalvataje) : setMonedaSalvataje('');
        isValidParam (liquidacionPerdida.mtoSalvataje) ? setMontoSalvataje(formato_monto(Math.round(liquidacionPerdida.mtoSalvataje))) : setMontoSalvataje('');
        isValidParam (liquidacionPerdida.mtoSalvataje) ? setMontoSalvatajeNoFormato(Math.round(liquidacionPerdida.mtoSalvataje)) : setMontoSalvatajeNoFormato('');
    }

    const handleClose = () => {
        setShow(false);
        setShowModalActLiquidacion(false);
        setActualizoLiquidacion(!actualizoLiquidacion);
        setModalValues({});
    }
    const handleCloseValidaciones = () => {
        setShowValidaciones(false);        
    }
    
    const handleSubmit = async () => {

        if (!valida()) {
            setShowValidaciones(true)
            return;
        }

        let liquidacion = {
            "idCaso": antecedentesCasos.antecedentesCasos[0].IdCaso,
            "idImplicadoCaso": 0,
            "idOrganizacion": antecedentesCasos.antecedentesCasos[0].Compania,
            "siniestro": antecedentesCasos.antecedentesCasos[0].Siniestro,
            "tipoSiniestro": antecedentesCasos.antecedentesCasos[0].IdTipoSiniestro,
            "tipoGestion": antecedentesCasos.antecedentesCasos[0].IdTipoGestion,
            "idLiquidador": antecedentesCasos.antecedentesCasos[0].IdLiquidador,
            "idAnalistaSin": antecedentesCasos.antecedentesCasos[0].IdAnalistaSiniestro,
            "fechaSiniestro": antecedentesCasos.antecedentesCasos[0].FechaSiniestro,
            "mdaPago": monedaPago,
            //"montoPago": montoPago,
            "mtoPago": montoPagoNoFormato,
            "fechaPago": fechaPago,
            "situacionPago": situacionPago,
            "mdaIndemniza": monedaIndemniza,
            //"mtoIndemnizacion": montoIndemniza,
            "mtoIndemnizacion": montoIndemnizaNoFormato,
            "fechaInforme": fechaInforme,
            "mdaProvision": monedaProvision,
            //"mtoProvision": montoProvision,
            "mtoProvision": montoProvisionNoFormato,
            "indInformeLiquida": chkInfLiquida,
            "indFiniquito": chkFiniquito,
            "mdaSalvataje": monedaSalvataje,
            "mtoSalvataje": montoSalvatajeNoFormato,
            "idUsuario": rutUsuario
        }        
        setLoading(true)
        const response = await servicePostActualizaLiquidacion(liquidacion);
        setLoading(false)
        setRespuestaActLiquidacion(response);
        setShow(true);
    }
    const valida = () => {

        let valido = true;
        if (montoPago && !isValidParam(monedaPago)) {
            validaciones.monedaPago = "Seleccione moneda.";
            valido = false;
        }
        if (montoIndemniza && !isValidParam(monedaIndemniza)) {
            validaciones.monedaIndemniza = "Seleccione moneda.";
            valido = false;
        }
        if (montoProvision && !isValidParam(monedaProvision)) {
            validaciones.monedaProvision = "Seleccione moneda.";
            valido = false;
        }
        if (montoSalvataje && !isValidParam(monedaSalvataje) && isValidParam(tipoSiniestro) && tipoSiniestro == 15001) {
            validaciones.monedaSalvataje = "Seleccione moneda.";
            valido = false;
        }
        
        let fpago = new Date(fechaPago);
        let finf = new Date(fechaInforme);
        let fsin = new Date(fechaSiniestro);

        if (fechaPago && fpago < fsin) {
            validaciones.fechaPago = "Fecha Pago debe ser mayor a Fecha Siniestro";
            valido = false;
        }
        if (fechaInforme && finf < fsin) {
            validaciones.fechaInforme = "Fecha Informe debe ser mayor a Fecha Siniestro";
            valido = false;
        }
        setValidaciones(validaciones);
        return valido;
    }
    return (
        <>
        <Modal show={showValidaciones} onHide={handleCloseValidaciones}>
            <Modal.Header closeButton>
            <Modal.Title>Validaciones...</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {"Complete campos requeridos."}
            </Modal.Body>
            {validaciones && <Modal.Footer>
            <Button variant='primary' onClick={handleCloseValidaciones}>
                Aceptar
            </Button>
            </Modal.Footer>}
        </Modal>
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Respuesta de la información enviada</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { respuestaActLiquidacion ? respuestaActLiquidacion.respuestaActLiquidacion["message"]:"Enviando..."} 
            </Modal.Body>
            {respuestaActLiquidacion && <Modal.Footer>
            <Button variant='primary' onClick={handleClose}>
                Aceptar
            </Button>
            </Modal.Footer>}
        </Modal>
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModalActLiquidacion} onHide={setShowModalActLiquidacion} size='xl'>
                <Card>
                    <Card.Header as='h6' style={{ backgroundColor: "rgb(209, 242, 235)", color: 'color: rgb(255, 255, 255)' }}>
                        Liquidación de Siniestro -  {antecedentesCasos && isValidParam(antecedentesCasos.antecedentesCasos[0]['TipoSiniestro']) ? antecedentesCasos.antecedentesCasos[0]['TipoSiniestro']:""}                    
                    </Card.Header>
                    {antecedentesCasos && antecedentesCasos.antecedentesCasos[0].IdTipoSiniestro == 15005 &&
                    <Card.Body >
                        <Row className='mb-3'>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-moneda-pago"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='codMonedaPago'
                                    value={monedaPago}
                                    onChange={e=>{                    
                                        setMonedaPago(e.target.value)
                                        validaciones.monedaPago="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaPago) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaPago}</Form.Text>) :""}
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-pago']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoPago(liquidacionPerdida && monedaPago == 30003 ? parseFloat(montoPago).toFixed(2) : formato_monto(Math.round(montoPago)))}
                                    onFocus={()=>setMontoPago(montoPagoNoFormato)}
                                    onChange={e=>{                    
                                        setMontoPago(e.target.value)
                                        setMontoPagoNoFormato(e.target.value)                                        
                                    }}
                                    name='montoPago'                   
                                    value={montoPago}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-fecha-pago']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    type="date"
                                    min={fechaSiniestro}
                                    //max={ fechaSin &&  parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                                    onChange={e=>{                    
                                        setFechaPago(e.target.value)
                                        validaciones.fechaPago="";
                                        setValidaciones(validaciones);
                                    }}
                                    name='fechaPago'                                
                                    value={fechaPago}
                                  ></Form.Control>
                                  {isValidParam(validaciones.fechaPago) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.fechaPago}</Form.Text>) :""}
                            </Col>
                            <Col md='3'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-situacion-pago"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='situacionPago'
                                    value={situacionPago}onChange={e=>{                    
                                        setSituacionPago(e.target.value)
                                    }}
                                    >
                                    <option value={''}>Seleccione...</option>
                                    {situaciones && situaciones
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                            </Col>
                            <Col>
                                <Form.Label className="label" >
                                    {cfg_form && cfg_form.cfg_form8['preparacartacobro-modal-actliq-cntPagos']}
                                </Form.Label>{' '}
                                <br />
                                <Form.Text className='mb-3'>
                                {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
                                    ? liquidacionPerdida.liquidacionPerdida['cntPagos']
                                    : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-moneda-indemniz"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='monedaIndemniza'
                                    value={monedaIndemniza}
                                    onChange={e=>{                    
                                        setMonedaIndemniza(e.target.value)
                                        validaciones.monedaIndemniza="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaIndemniza) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaIndemniza}</Form.Text>) :""}
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-indemniza']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoIndemniza(liquidacionPerdida && monedaIndemniza == 30003 ? parseFloat(montoIndemniza).toFixed(2) : formato_monto(Math.round(montoIndemniza)))}
                                    onFocus={()=>setMontoIndemniza(montoIndemnizaNoFormato)}
                                    onChange={e=>{                    
                                        setMontoIndemniza(e.target.value)
                                        setMontoIndemnizaNoFormato(e.target.value)                                        
                                    }}
                                    name='montoIndemniza'                   
                                    value={montoIndemniza}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                            <Col md='2'>
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-chk-informe']}
                                </Form.Label>
                                <br />
                                <Form.Check 
                                    type="checkbox" 
                                    checked={chkInfLiquida} 
                                    name="chkInfLiquida" 
                                    id="chkInfLiquida" 
                                    onChange={e=>{
                                        setChkInfLiquida(e.target.checked)                                                              
                                    }}/>
                            </Col>                        
                            <Col md='3'>
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-fechainforme']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    type="date"
                                    min={fechaSiniestro}
                                    //max={ fechaSin &&  parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                                    onChange={e=>{                    
                                        setFechaInforme(e.target.value)
                                        validaciones.fechaInforme="";
                                        setValidaciones(validaciones);
                                    }}
                                    name='fechaInforme'                                
                                    value={fechaInforme}
                                  ></Form.Control>
                                  {isValidParam(validaciones.fechaInforme) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.fechaInforme}</Form.Text>) :""}
                            </Col>
                            <Col>
                                <Form.Label className="label" >
                                    {cfg_form && cfg_form.cfg_form8['preparacartacobro-modal-actliq-cntFacturas']}
                                </Form.Label>{' '}
                                <br />
                                <Form.Text className='mb-3'>
                                {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
                                    ? liquidacionPerdida.liquidacionPerdida['cntFacturas']
                                    : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-moneda-provisio"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='monedaProvision'
                                    value={monedaProvision}
                                    onChange={e=>{                    
                                        setMonedaProvision(e.target.value)
                                        validaciones.monedaProvision="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaProvision) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaProvision}</Form.Text>) :""}
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-provision']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoProvision(liquidacionPerdida && monedaProvision == 30003 ? parseFloat(montoProvision).toFixed(2) : formato_monto(Math.round(montoProvision)))}
                                    onFocus={()=>setMontoProvision(montoProvisionNoFormato)}
                                    onChange={e=>{                    
                                        setMontoProvision(e.target.value)
                                        setMontoProvisionNoFormato(e.target.value)                                        
                                    }}
                                    name='montoProvision'                   
                                    value={montoProvision}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                        </Row>
                    </Card.Body>
                    }
                    {antecedentesCasos && antecedentesCasos.antecedentesCasos[0].IdTipoSiniestro == 15001 &&
                    <Card.Body >
                        <Row className='mb-3'>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-moneda-indemniz"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='monedaIndemniza'
                                    value={monedaIndemniza}
                                    onChange={e=>{                    
                                        setMonedaIndemniza(e.target.value)
                                        validaciones.monedaIndemniza="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaIndemniza) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaIndemniza}</Form.Text>) :""}
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-indemniza']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoIndemniza(liquidacionPerdida && monedaIndemniza == 30003 ? parseFloat(montoIndemniza).toFixed(2) : formato_monto(Math.round(montoIndemniza)))}
                                    onFocus={()=>setMontoIndemniza(montoIndemnizaNoFormato)}
                                    onChange={e=>{                    
                                        setMontoIndemniza(e.target.value)
                                        setMontoIndemnizaNoFormato(e.target.value)                                        
                                    }}
                                    name='montoIndemniza'                   
                                    value={montoIndemniza}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                            <Col md='2'>
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-chk-informe']}
                                </Form.Label>
                                <br />
                                <Form.Check 
                                    type="checkbox" 
                                    checked={chkInfLiquida} 
                                    name="chkInfLiquida" 
                                    id="chkInfLiquida" 
                                    onChange={e=>{
                                        setChkInfLiquida(e.target.checked)                                                              
                                    }}/>
                            </Col>                        
                            <Col md='3'>
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-fechainforme']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    type="date"
                                    min={fechaSiniestro}
                                    //max={ fechaSin &&  parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                                    onChange={e=>{                    
                                        setFechaInforme(e.target.value)
                                        validaciones.fechaInforme="";
                                        setValidaciones(validaciones);
                                    }}
                                    name='fechaInformePT'                                
                                    value={fechaInforme}
                                  ></Form.Control>
                                  {isValidParam(validaciones.fechaInforme) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.fechaInforme}</Form.Text>) :""}
                            </Col>
                            <Col>
                                <Form.Label className="label" >
                                    {cfg_form && cfg_form.cfg_form8['preparacartacobro-modal-actliq-sitSalvataje']}
                                </Form.Label>{' '}
                                <br />
                                <Form.Text className='mb-3'>
                                {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
                                    ? liquidacionPerdida.liquidacionPerdida['sitSalvataje']
                                    : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-moneda-pago"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='codMonedaPago'
                                    value={monedaPago}
                                    onChange={e=>{                    
                                        setMonedaPago(e.target.value)
                                        validaciones.monedaPago="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaPago) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaPago}</Form.Text>) :""}
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-pago']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoPago(liquidacionPerdida && monedaPago == 30003 ? parseFloat(montoPago).toFixed(2) : formato_monto(Math.round(montoPago)))}
                                    onFocus={()=>setMontoPago(montoPagoNoFormato)}
                                    onChange={e=>{                    
                                        setMontoPago(e.target.value)
                                        setMontoPagoNoFormato(e.target.value)                                        
                                    }}
                                    name='montoPago'                   
                                    value={montoPago}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                            <Col md='2'>
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-chk-finiquito']}
                                </Form.Label>
                                <br />
                                <Form.Check 
                                    type="checkbox" 
                                    checked={chkFiniquito} 
                                    name="chkFiniquito" 
                                    id="chkFiniquito" 
                                    onChange={e=>{
                                        setChkFiniquito(e.target.checked)                                                              
                                    }}/>
                            </Col>   
                            <Col md="3">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-fecha-pago']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    type="date"
                                    min={fechaSiniestro}
                                    //max={ fechaSin &&  parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                                    onChange={e=>{                    
                                        setFechaPago(e.target.value)
                                        validaciones.fechaPago="";
                                        setValidaciones(validaciones);
                                    }}
                                    name='fechaPagoPT'                                
                                    value={fechaPago}
                                  ></Form.Control>
                                  {isValidParam(validaciones.fechaPago) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.fechaPago}</Form.Text>) :""}
                            </Col>
                            <Col>
                                <Form.Label className="label" >
                                    {cfg_form && cfg_form.cfg_form8['preparacartacobro-modal-actliq-factvta']}
                                </Form.Label>{' '}
                                <br />
                                <Form.Text className='mb-3'>
                                {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
                                    ? liquidacionPerdida.liquidacionPerdida['indicaFacturaVenta'] == 1 ? "SI" : "NO"
                                    : null}
                                </Form.Text>
                            </Col>
                        </Row>
                        <Row className='mb-3'>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-moneda-provisio"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='monedaProvision'
                                    value={monedaProvision}
                                    onChange={e=>{                    
                                        setMonedaProvision(e.target.value)
                                        validaciones.monedaProvision="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaProvision) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaProvision}</Form.Text>) :""}
                            </Col>
                            <Col md="2">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-provision']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoProvision(liquidacionPerdida && monedaProvision == 30003 ? parseFloat(montoProvision).toFixed(2) : formato_monto(Math.round(montoProvision)))}
                                    onFocus={()=>setMontoProvision(montoProvisionNoFormato)}
                                    onChange={e=>{                    
                                        setMontoProvision(e.target.value)
                                        setMontoProvisionNoFormato(e.target.value)                                        
                                    }}
                                    name='montoProvision'                   
                                    value={montoProvision}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                            <Col md='2'>
                                <Form.Label className="label">
                                    {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-cmb-mon-salvataje"]}
                                </Form.Label>
                                <br />
                                <Form.Select
                                    readOnly
                                    name='monedaSalvataje'
                                    value={monedaSalvataje}
                                    onChange={e=>{                    
                                        setMonedaSalvataje(e.target.value)
                                        validaciones.monedaSalvataje="";
                                        setValidaciones(validaciones);
                                    }}
                                    >                                    
                                    <option value={''}>Seleccione...</option>
                                    {monedas && monedas
                                        .filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                        .map((c) => (<option key={c.id} value={c.id}>{c.nombre}</option>))
                                    }
                                </Form.Select>
                                {isValidParam(validaciones.monedaSalvataje) ? (<Form.Text variant="danger" style={{color:"red"}} >{validaciones.monedaSalvataje}</Form.Text>) :""}
                            </Col>
                            <Col md="3">
                                <Form.Label className='label'>
                                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-modal-actliq-monto-salvataje']}
                                </Form.Label>
                                <br />
                                <Form.Control
                                    aria-label='Default select example'
                                    onKeyDown={e=>validaNumeros(e)}
                                    onBlur={()=>setMontoSalvataje(liquidacionPerdida && monedaSalvataje == 30003 ? parseFloat(montoSalvataje).toFixed(2) : formato_monto(Math.round(montoSalvataje)))}
                                    onFocus={()=>setMontoSalvataje(montoSalvatajeNoFormato)}
                                    onChange={e=>{                    
                                        setMontoSalvataje(e.target.value)
                                        setMontoSalvatajeNoFormato(e.target.value)                                        
                                    }}
                                    name='montoSalvataje'                   
                                    value={montoSalvataje}
                                    //error={formik.errors.montoRecobro} 
                                ></Form.Control>
                            </Col>
                        </Row>
                    </Card.Body>
                    }
                    <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                        <Button className='w-auto' variant='outline-info' onClick={handleClose}>
                            {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-btn-volver"]}
                        </Button>
                        <Button type="w-auto" className='w-auto buttonLetter' variant='danger' onClick={handleSubmit}>
                            {cfg_form && cfg_form.cfg_form8["preparacartacobro-modal-actliq-btn-act"]}
                        </Button>
                    </Card.Footer>

                </Card>

            </Modal>
        <style type='text/css'>
            {`
                .is_required:after {
                    content: "*";
                    margin-left: 2px;
                    color: #000;
                    font-weight: 500;
                    font-size: 12pt;
                }
                .not_required:after {
                    margin-left: 2px;
                    color: #000;
                    font-weight: 500;
                    font-size: 12pt;
                }
                .label {
                    font-weight: bold;
                    font-size: 14px;
                }
            `}
        </style>
    </Fragment>
    </>
    )
}

export default ActualizaLiquidacion;